<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------

========================================================================================== -->


<template>
  <div class="relative">
    <div id="vs_navbar" class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          :class="[
            'sm:inline-flex xl cursor-pointer p-2',
            { 'xl:hidden': $route.fullPath.includes('admin') },
          ]"
          id="featherIcon"
          icon="MenuIcon"
          @click="showSidebar"
        />

        <title-route :class="{ 'pl-3': showSidebar }" />

        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->

        <vs-spacer />

        <!-- <search-bar class="mr-4" />

        <notification-drop-down /> -->

        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>


<script>
import TitleRoute from "./components/TitleRoute.vue";
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    TitleRoute,
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor !== "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor !== "#fff" && this.$store.state.theme !== "dark"),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.$route.fullPath.includes("admin")) {
        return "vx-navbar-wrapper navbar-full";
      }
      if (this.$store.state.activeNavBar) {
        return "vx-navbar-wrapper navbar-full";
      } else {
        return "vx-navbar-wrapper is_reduce";
      }
    },
  },
  methods: {
    showSidebar(e) {
      if (this.windowWidth >= 1200) {
        this.$store.dispatch("updateActiveNavBar");
        let sidebar = document.getElementById("sidebarMenu");
        let vsContent = document.getElementById("vs_maincontent");
        let vsNavbar = document.getElementById("vs_navbar");
        let vsContentArea = document.getElementById("content-area");
        if (!this.$store.state.activeNavBar) {
          this.$store.commit("SAVE_RESIZEABLE_NAV_BAR", e.pageX);
          //Hidden sidebar
          sidebar.classList.add("is_hidden");
          if (sidebar.childNodes[1].childNodes[1].offsetWidth != 260) {
            //Set inner sidebar items transition and width if width != 260px
            sidebar.childNodes[1].childNodes[1].style.width = "0px";
          }
          //Calculate the navbar and content area width
          vsNavbar.style.width = `${window.innerWidth - 10 * 2}px`;
          vsNavbar.style.marginLeft = "0px";
          vsContentArea.style.width = `${window.innerWidth - 10 * 2}px`;
        } else {
          vsNavbar.style.width = `${window.innerWidth - 260 - 10 * 2}px`;
          vsNavbar.style.marginLeft = "0px";

          vsContentArea.style.width = `${window.innerWidth - 260 - 10 * 2}px`;
          //Remove duplicate sidebar
          try {
            sidebar.remove();
          } catch (err) {}
        }
        // vsContent.style.transition = "";
        // vsNavbar.style.transition = "";
      } else {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
  },
};
</script>

<style lang="scss">
#vs_navbar {
  transition: 0.5s;
}
</style>

